export const selectFiltersSelected = (state) => state.baseFilters.selected;
